import React, { createContext } from 'react';
import PropTypes from 'prop-types';

const VinContext = createContext('');

const VinContextProvider = ({ vin, children }) => <VinContext.Provider value={vin}>{children}</VinContext.Provider>;

VinContextProvider.propTypes = {
  vin: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

export { VinContext, VinContextProvider };
